import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const AmericanFootball = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 28}
        height={size ?? 28}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1305_4265)">
          <path
            opacity="0.944"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.792969 0.410162C1.13544 0.37582 1.46357 0.421393 1.77734 0.546881C1.82985 0.624504 1.87543 0.706535 1.91406 0.792975C1.94141 6.31636 1.95052 11.8398 1.94141 17.3633C1.43099 17.3633 0.920571 17.3633 0.410156 17.3633C0.401042 11.8581 0.410156 6.35283 0.4375 0.847662C0.469395 0.624958 0.587885 0.479125 0.792969 0.410162Z"
            fill={color}
          />
          <path
            opacity="0.971"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.7617 0.410159C17.0587 0.39162 17.3504 0.418964 17.6367 0.49219C17.7214 0.558581 17.7852 0.640612 17.8281 0.738284C17.8737 3.21765 17.8646 5.6968 17.8008 8.17578C17.3425 8.01796 16.8776 7.89037 16.4063 7.79297C16.3698 5.44141 16.3698 3.08985 16.4063 0.738284C16.4848 0.577399 16.6033 0.468026 16.7617 0.410159Z"
            fill={color}
          />
          <path
            opacity="0.909"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.9023 8.61328C15.1449 8.59742 15.3819 8.62477 15.6133 8.69531C14.1641 9.63414 12.9701 10.8281 12.0312 12.2773C11.8417 10.1353 12.7988 8.91396 14.9023 8.61328Z"
            fill={color}
          />
          <path
            opacity="0.976"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.0898 8.94141C19.8089 9.71813 21.7685 11.3952 22.9688 13.9727C23.127 14.338 23.2637 14.7116 23.3789 15.0938C22.9747 16.0761 22.4005 16.942 21.6562 17.6914C20.1341 16.1693 18.612 14.6471 17.0898 13.125C16.713 12.9837 16.476 13.1113 16.3789 13.5078C16.4242 13.6071 16.4699 13.7074 16.5156 13.8086C18.0195 15.3125 19.5234 16.8164 21.0273 18.3203C20.2928 19.0638 19.436 19.6199 18.457 19.9883C16.1828 19.3088 14.4237 17.9599 13.1797 15.9414C12.7967 15.2756 12.4959 14.5738 12.2773 13.8359C12.6733 12.8696 13.2384 12.0219 13.9727 11.293C14.3456 11.6385 14.7102 11.994 15.0664 12.3594C15.456 12.5696 15.7112 12.4603 15.832 12.0312C15.8252 11.9423 15.7979 11.8602 15.75 11.7852C15.3664 11.4107 14.9927 11.0278 14.6289 10.6367C15.348 9.92195 16.1683 9.35681 17.0898 8.94141Z"
            fill={color}
          />
          <path
            opacity="0.97"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.81641 12.9883C5.60547 12.9883 8.39453 12.9883 11.1836 12.9883C11.2412 13.4738 11.3506 13.9478 11.5117 14.4102C8.6135 14.4648 5.71506 14.4831 2.81641 14.4648C2.81641 13.9727 2.81641 13.4805 2.81641 12.9883Z"
            fill={color}
          />
          <path
            opacity="0.91"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.5977 16.6523C23.755 17.6813 23.509 18.611 22.8594 19.4414C22.0238 20.1208 21.0667 20.4034 19.9883 20.2891C21.4581 19.3388 22.6612 18.1265 23.5977 16.6523Z"
            fill={color}
          />
          <path
            opacity="0.974"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-0.0273438 27.2617C-0.0273438 24.3633 -0.0273438 21.4648 -0.0273438 18.5664C0.0407877 18.4351 0.150163 18.3531 0.300781 18.3203C0.902344 18.2838 1.50391 18.2838 2.10547 18.3203C2.27842 18.4012 2.37869 18.538 2.40625 18.7305C2.44271 21.5195 2.44271 24.3086 2.40625 27.0977C2.3829 27.3179 2.26441 27.4546 2.05078 27.5078C1.48568 27.5443 0.920571 27.5443 0.355469 27.5078C0.205988 27.4584 0.0783841 27.3763 -0.0273438 27.2617Z"
            fill={color}
          />
          <path
            opacity="0.916"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.9726 20.4805C27.9726 20.6445 27.9726 20.8086 27.9726 20.9727C27.7717 21.2408 27.5164 21.3046 27.207 21.1641C26.5781 20.5352 25.9492 19.9062 25.3203 19.2773C25.1855 18.7011 25.4134 18.455 26.0039 18.5391C26.6893 19.1606 27.3455 19.8078 27.9726 20.4805Z"
            fill={color}
          />
          <path
            opacity="0.97"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.8867 19.8789C16.6475 20.3138 17.4496 20.6602 18.293 20.918C18.3568 23.0141 18.3659 25.1104 18.3203 27.207C18.2514 27.3672 18.1329 27.4674 17.9649 27.5078C17.3998 27.5443 16.8346 27.5443 16.2695 27.5078C16.1015 27.4674 15.983 27.3672 15.9141 27.207C15.8867 24.7644 15.8776 22.3217 15.8867 19.8789Z"
            fill={color}
          />
          <path
            opacity="0.918"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.9727 23.8711C27.9727 24.0352 27.9727 24.1992 27.9727 24.3633C27.7379 24.6451 27.4645 24.6908 27.1523 24.5C26.1406 23.4883 25.1289 22.4766 24.1172 21.4648C23.9258 20.7812 24.1719 20.5352 24.8555 20.7266C25.9071 21.769 26.9461 22.8172 27.9727 23.8711Z"
            fill={color}
          />
          <path
            opacity="0.915"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.3398 21.8477C22.4724 21.8766 22.6 21.9222 22.7226 21.9844C23.3151 22.5768 23.9076 23.1693 24.5 23.7617C24.7227 24.2053 24.5951 24.497 24.1172 24.6367C23.9944 24.6019 23.8759 24.5563 23.7617 24.5C23.1693 23.9076 22.5768 23.3151 21.9844 22.7227C21.7721 22.2952 21.8906 22.0035 22.3398 21.8477Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_1305_4265">
            <rect width="28" height="28" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);

export default AmericanFootball;
